<template>
  <div>
    <vs-loading :loading="loading"></vs-loading>
    <vs-card>
      <div class="tw-flex tw-justify-between">
        <vs-select
          class=""
          label="Sayfada Gösterilecek Kayıt Sayısı"
          v-model="pageSize"
          @change="handlePageSizeChange"
        >
          <vs-select-item
            v-for="size in pageSizes"
            :key="size"
            :value="size"
            :text="size"
          />
        </vs-select>

        <vs-paginator
          v-if="meta"
          :meta="meta"
          @change="handlePageChange"
        ></vs-paginator>
        <div class="paginat">
          <vs-paginator
            v-if="meta2"
            :meta="meta2"
            @change="handlePageChange"
          ></vs-paginator>
          <vs-paginator
            v-if="meta3"
            :meta="meta3"
            @change="handlePageChange"
          ></vs-paginator>
          <vs-paginator
            v-if="meta4"
            :meta="meta4"
            @change="handlePageChange"
          ></vs-paginator>
        </div>
      </div>
    </vs-card>

    <vs-card>
      <div slot="header">
        <div class="tw-flex tw-justify-between">
          <h3>Etkinlik Kayıt Oluşturma</h3>
        </div>
      </div>

      <div class="tw-flex tw-flex-wrap">
        <div class="tw-w-full tw-flex tw-justify-between tw-items-center">
          <div class="tw-flex">
            <vs-input
              icon="mdi-magnify"
              placeholder="Arama"
              v-model="search"
              v-on:keyup.enter="
                page = 1;
                get();
              "
            />
            <!--eski etkinlik listesi adları 9X geliyor. -->
          </div>
          <vs-button
            color="primary"
            type="filled"
            class="butonYeniEkle"
            :to="{
              name: 'appeals-create',
              params: {
                parametre3: this.gonderilecek3,
                appealCount: this.appealsCounter,
                parametre33: this.gonderilecek33,
              },
            }"
          >
            Yeni Ekle
          </vs-button>
        </div>

        <div class="tw-w-full">
          <vs-divider></vs-divider>
        </div>

        <div class="tw-w-full lg:tw-w-5/5">
          <div v-if="loading">Loading...</div>

          <vs-table stripe :data="list">
            <template slot="header">
              <h3>Etkinlik Bilgileri</h3>
            </template>
            <template slot="thead">
              <!--  <vs-th>Etkinlik ID</vs-th> -->
              <vs-th class="tarbuyutucu">Etkinlik Kayıt No.</vs-th>
              <vs-th class="tarbuyutucu">Tarih</vs-th>
              <vs-th>Saat</vs-th>
              <vs-th>Yer</vs-th>
              <vs-th>Etkinlik Türü</vs-th>
              <vs-th>Etkinlik Adı</vs-th>
              <!--<vs-th>Sürdürülebilir Kalkınma Amaçları</vs-th> -->
              <vs-th>Oluşturan</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="(item, i) in data" :key="i">
                <vs-td :data="item.id">
                  <div class="fontt2" @click="show(item, i)">
                    {{ item.appealId }}
                  </div>
                </vs-td>
                <vs-td :data="item.startDate">
                  <div @click="show(item, i)">{{ item.startDate }}</div>
                </vs-td>
                <vs-td :data="item.startTime">
                  <div class="fontt" @click="show(item, i)">
                    {{ item.startTime }}
                  </div>
                </vs-td>
                <vs-td :data="item.room">
                  <div class="fontt" @click="show(item, i)">
                    {{ item.room }}
                  </div>
                </vs-td>
                <vs-td :data="item.eventType">
                  <div class="fontt" @click="show(item, i)">
                    {{ item.eventType }}
                  </div>
                </vs-td>

                <vs-td :data="item.eventName">
                  <div class="fontt" @click="show(item, i)">
                    {{ item.eventName }}
                  </div>
                </vs-td>

                <vs-td :data="item.relatedEvent">
                  <div class="fontt" @click="show(item, i)">
                    {{ item.createdBy }}
                  </div>
                </vs-td>

                <!--  <vs-td :data="item">
                    <vs-button  color="#32bebe" icon-pack="mdi" icon="mdi-favorite" @click="detayaGit(item)">Güncelle</vs-button>
                  </vs-td>
                  
                 <vs-td :data="item.id">
                                 <vs-button class="butonlar" type="gradient" color="danger" icon-pack="mdi" icon="mdi-favorite"  @click="silmeYap(item.id)">Sil</vs-button>      
                </vs-td>-->
              </vs-tr>
            </template>
          </vs-table>

          <!--<vs-button type="gradient" color="danger" @click="removeAll">Tümünü Sil</vs-button>-->
        </div>

        <div class="tw-w-full lg:tw-w-1/5 lg:tw-pl-5">
          <!-- <vs-card v-if="selected">
         
            <div class="header1" >
              <h3>{{ selected.eventName }}</h3>
            </div>
            <div class="close-button" slot="header">
              <vs-row vs-justify="flex-end">
                <vs-button close type="gradient" color="danger" icon-pack="mdi" icon="mdi-favorite" @click="func">X &nbsp</vs-button>
              </vs-row>
            </div>
            
            <div>
            
              <div>
              
                <strong>Durum: </strong> {{ obj.columns.published ? "Kaydedildi" : "Kaydedilmedi" }}
              </div>
            </div>
            <div slot="footer">
              <vs-row vs-justify="flex-end">
                <vs-button type="gradient" color="warning" icon-pack="mdi" icon="mdi-favorite" :to="{name: 'appeals-show', params: {id: selected.id}}">Detaylar</vs-button>
              </vs-row>
            </div>
          </vs-card>-->

          <!--<div v-else>
            <br />
            <vs-alert active="true" color="info">
            <div class="text-center">
              Görüntülemek için etkinlik seçiniz.</div>
            </vs-alert>
          </div>-->
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import { paginatorMixin } from "@/mixins/paginatorMixin";
import Appeal from "@/libs/appeals/Appeal";
import Inst from "@/libs/insts/Inst";
import Ev from "@/libs/evs/Ev";
import Roo from "@/libs/roos/Roo";
import { isAuthenticated, getUserFromStorage } from "@/utils/Customs";
import User from "@/libs/users/User";

export default {
  name: "appeals-index",
  title: "Kayıt",

  mixins: [paginatorMixin],

  data() {
    return {
      paginat: false,
      user: getUserFromStorage(),
      obj: new Appeal(),
      obj22: new Appeal(),
      obj2: new Ev(),
      obj33: new User(),
      obj3: new Roo(),
      obj5: new Inst(),
      isimler: [],
      appealsCounter: [],
      gonderilecek: [],

      gonderilecek2: [],
      gonderilecek3: [],
      gonderilecek33: [],
      gonderilecekPaket: [],
      search: "",
      loading: false,
    };
  },

  computed: {
    users() {
      return this.obj33.users;
    },
    appeals() {
      return this.obj.appeals;
    },
    appealsEt() {
      return this.obj22.appeals;
    },
    insts() {
      return this.obj5.insts;
    },
    evs() {
      return this.obj2.evs;
    },
    roos() {
      return this.obj3.roos;
    },

    selected() {
      return this.obj.selected;
    },

    saved() {
      return this.obj.saved;
    },

    deleted() {
      return this.obj.deleted;
    },

    list() {
      if (this.roos && this.roos.data) {
        this.gonderilecek3 = this.roos.data;
        //console.log(this.etkinlikListesi[0].eventName)
      }
      if (this.appeals && this.appeals.data) {
        this.appealsCounter = this.appeals.data;
      }

      if (this.appealsEt && this.appealsEt.data) {
        for (let i = 0; i < this.appealsEt.data.length; i++) {
          if (this.appealsEt.data[i].published != "Silindi") {
            this.isimler.push(this.appealsEt.data[i]);
          }
        }
        //console.log(this.etkinlikListesi[0].eventName)
      }
      if (
        this.user.adKullaniciAdi == "admin" ||
        this.user.adKullaniciAdi == "meryem.aciksoz" ||
        this.user.adKullaniciAdi == "gokce.ozer"
      ) {
        if (this.appeals && this.appeals.data) {
          const etkinliklerim = this.appeals.data;
          const etkinliklerimTemp = [];

          for (let i = 0; i < etkinliklerim.length; i++) {
            if (etkinliklerim[i].published != "Silindi") {
              etkinliklerimTemp.push(etkinliklerim[i]);
            }
          }

          return etkinliklerimTemp;
        }
      } else if (this.user.rol == "İdari Admin") {
        if (this.appeals && this.appeals.data) {
          const etkinliklerim = this.appeals.data;
          const etkinliklerimTemp = [];

          for (let i = 0; i < etkinliklerim.length; i++) {
            if (
              (etkinliklerim[i].hbvunits == this.user.unit ||
                etkinliklerim[i].createdBy == this.user.adKullaniciAdi) &&
              etkinliklerim[i].published != "Silindi"
            ) {
              etkinliklerimTemp.push(etkinliklerim[i]);
            }
          }

          return etkinliklerimTemp;
        }
      } else {
        if (this.appeals && this.appeals.data) {
          const etkinliklerim = this.appeals.data;
          const etkinliklerimTemp = [];

          for (let i = 0; i < etkinliklerim.length; i++) {
            if (
              etkinliklerim[i].createdBy == this.user.adKullaniciAdi &&
              etkinliklerim[i].published != "Silindi"
            ) {
              etkinliklerimTemp.push(etkinliklerim[i]);
            }
          }

          return etkinliklerimTemp;
        }
      }

      return [];
    },
    listInst() {
      if (this.insts && this.insts.data) {
        this.gonderilecek = this.insts.data;

        return this.insts.data;
      }
      return [];
    },
    list2() {
      if (this.evs && this.evs.data) {
        this.gonderilecek2 = this.evs.data;

        return this.evs.data;
      }
      return [];
    },
    list3() {
      if (this.roos && this.roos.data) {
        this.gonderilecek3 = this.roos.data;

        return this.roos.data;
      }
      return [];
    },

    list4() {
      if (this.users && this.users.data) {
        this.gonderilecek33 = this.users.data;
        //console.log("sa")
        return this.users.data;
      }
      return [];
    },

    meta() {
      if (this.appeals && this.appeals.meta) {
        let f = this.list4;
        return this.appeals.meta;
      }
      return null;
    },
    meta2() {
      if (this.insts && this.insts.meta) return this.insts.meta;

      return null;
    },
    meta3() {
      if (this.evs && this.evs.meta) return this.evs.meta;

      return null;
    },
    meta4() {
      if (this.roos && this.roos.meta) return this.roos.meta;

      return null;
    },
    meta33() {
      if (this.users && this.users.meta) return this.users.meta;

      return null;
    },

    submitted() {
      return this.obj.form.submitted;
    },

    contaminated() {
      return this.obj.form.errorDetected;
    },
  },

  watch: {
    contaminated(val) {
      this.loading = false;
    },

    submitted(val) {
      if (val) this.loading = false;
    },

    saved(val) {
      if (val) this.get();
    },

    deleted(val) {
      if (val) this.get();
    },
  },

  methods: {
    idTempCal(item) {
      let count = 0;
      for (let i = 0; i < this.appeals.data.length; i++) {
        if (this.appeals.data[i].id == item.id) {
          return this.$idTemp + i;
        }
      }
    },
    etkinlikGoster(item, i) {
      if (item.published == "Silindi") {
        return false;
      }
      return true;
    },
    silmeYap(itemid) {
      this.$confirm({
        message: `Etkinliği Silmek İstiyor Musunuz?`,
        button: {
          no: "Hayır",
          yes: "Evet",
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: (confirm) => {
          if (confirm) {
            this.obj.delete(itemid);
          }
        },
      });
    },
    detayaGit(item) {
      this.$router.push({
        name: "appeals-show",
        params: {
          id: item.id,
          parametre3: this.gonderilecek3,
          parametre33: this.gonderilecek33,
        },
      });
    },
    get() {
      const params = this.getRequestParams(
        this.search,
        this.page,
        this.pageSize
      );

      this.loading = true;
      this.obj.getAll(params);
    },
    getEtkinlik() {
      const params = this.getRequestParams(this.search, this.page, 10);

      this.loading = false;
      this.obj22.getAll(params);
    },
    getInst() {
      const params = this.getRequestParams(this.search, this.page, 10);

      this.loading = true;
      this.obj5.getAll(params);
    },
    get2() {
      const params = this.getRequestParams(this.search, this.page, 10);

      this.loading = true;
      this.obj2.getAll(params);
    },
    /*  get3() {
        const params = this.getRequestParams(
          this.search,
          this.page,
          10
        );

        this.loading = true
        this.obj33.getAll(params)
        
      }, */

    handlePageChange(page) {
      this.page = page;
      this.get();
      this.getInst();
      this.get2();
      let d = this.listInst;
      let e = this.list2;
      let f = this.list3;
    },

    handlePageSizeChange() {
      this.page = 1;
      this.get();
      this.getEtkinlik();
      this.getInst();
      this.get2();
      let d = this.meta2;
      let e = this.meta3;
      let ee = this.meta33;
      let f = this.meta4;
    },

    refreshList() {
      this.get();
      this.getInst();
      this.getEtkinlik();
      let d = this.meta2;
      let e = this.meta3;
      let ee = this.meta33;
      let f = this.meta4;
      this.obj.selected = null;
    },

    show(item, index) {
      this.obj.selected = item;
    },

    removeAll() {
      //this.loading = true
      this.obj.deleteAll();
    },
    func() {
      this.obj.selected = null;
    },
  },

  mounted() {
    this.get();
    this.getInst();
    this.getEtkinlik();
    this.get2();

    //let a=this.listAll
  },
};
</script>

<style>
.paginat {
  display: none;
}
.vs-component.vs-button.vs-button-danger.vs-button-gradient {
  color: white;
}
.vs-component.vs-button.vs-button-primary.vs-button-filled {
  color: white;
}
.vs-component.vs-button.vs-button-null.vs-button-filled {
  color: white;
}

.vs-pagination--li.is-current .effect {
  background-color: #e6272d !important;
  border-radius: 25px;
}
.item-pagination.vs-pagination--li.span {
  display: none;
}

.header1 {
  display: inline-block;
  margin-right: 10px;
}
.close1 {
  text-align: center;
}
.fonttTar {
  width: 10%;
}
.vs-con-table.stripe .tr-values:nth-child(2n) {
  background: #f0f0f0 !important;
}

.butonYeniEkle {
  color: white;
  font-size: 13px;
}

.tarbuyutucu {
  width: 12%;
}
</style>
